class formatNumber {
    constructor(filter) {

        this.filter = filter;
        this.require = '?ngModel';
        this.link = (scope, elem, attrs, ctrl) => {
            if (!ctrl) return;

            ctrl.$formatters.unshift(() => {
                let valueInFormatter = this.filter('number')(ctrl.$modelValue);
                return valueInFormatter;
            });

            ctrl.$parsers.unshift((goog) => {
                let plainNumber = goog.replace(/[\,\.]/g, '');
                let formattedNumber = this.filter('number')(plainNumber);
                formattedNumber = convertZeroToEmptyString(formattedNumber)
                elem.val(formattedNumber);
                return plainNumber;
            });

            function convertZeroToEmptyString(formattedNumber) {
                if (formattedNumber === '0') return '';
                else return formattedNumber;
            }
        }
    }

    /**
     * Factory
     * @return {Object}
     */
    static directiveFactory($filter) {
        formatNumber.instance = new formatNumber($filter);
        return formatNumber.instance;
    }
}

export default formatNumber;



/** WEBPACK FOOTER **
 ** ./src/app/directives/common/formatNumber.js
 **/